import React from 'react';
import PropTypes from 'prop-types';

import InspectionScheduled from '@/components/common/icons/activity-log/inspection-scheduled.svg';
import OrderCreated from '@/components/common/icons/activity-log/order-created.svg';
import renderSvg from '@/utils/renderSvg';

const icons = {
  CHECKIN: InspectionScheduled,
};

const Icon = ({ action, className }) =>
  renderSvg(icons[action] || OrderCreated, { className, alt: action });

Icon.propTypes = {
  action: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
